import React from 'react';
import { cn } from 'src/lib/utils';

const ComponentBox = ({ label, dark = false, children, className }) => (
  <div
    className={cn(
      'rounded-2xl p-8 border mb-6',
      dark ? 'bg-sidebar text-sidebar-foreground border-sidebar-border' : 'bg-card border-border shadow-sm',
      className,
    )}>
    <div
      className={cn(
        'font-mono text-[10px] tracking-[0.12em] uppercase mb-5 pb-3 border-b',
        dark ? 'text-primary border-sidebar-border' : 'text-muted-foreground border-border',
      )}>
      {label}
    </div>
    {children}
  </div>
);

export { ComponentBox };
